/*eslint-disable*/ export const messages = JSON.parse("{\"button.aria.loading\":[\"Loading...\"]}");
//# sourceMappingURL=messages.mjs.map